import { render, staticRenderFns } from "./GetDayVip.vue?vue&type=template&id=f7ac48ac&"
import script from "./GetDayVip.vue?vue&type=script&lang=js&"
export * from "./GetDayVip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports